import type { JSPrimitive } from './types';

export type DeepReadonly<T> = T extends JSPrimitive ? T : DeepReadonlyObject<T>;
type DeepReadonlyObject<T> = {
    readonly [P in keyof T]: DeepReadonly<T[P]>;
};

export type DeepMutable<T> = T extends JSPrimitive ? T : MutableObject<T>;
type MutableObject<T> = { [P in keyof T]: T[P] };

/**
 * Freeze an object and all its properties recursively.
 */
export function deepFreeze<T extends object>(o: T): DeepReadonly<T> {
    const result = Object.freeze(o);
    Object.getOwnPropertyNames(result).forEach((prop) => {
        if (
            // @ts-ignore
            result[prop] !== null &&
            // @ts-ignore
            (typeof result[prop] === 'object' || typeof result[prop] === 'function') &&
            // @ts-ignore
            !Object.isFrozen(result[prop])
        ) {
            // @ts-ignore
            deepFreeze(result[prop]);
        }
    });

    // @ts-expect-error
    return result;
}
